import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Col, Row} from 'react-grid-system'
import './Record.css';
import _ from "underscore";
import {Link} from 'react-router-dom'
import jsonata from 'jsonata';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

class Record extends Component {

    componentDidMount() {
        window.scrollTo(0, document.getElementById('Incredible-Root').offsetTop);
    }
    componentDidUpdate() {
        window.scrollTo(0, document.getElementById('Incredible-Root').offsetTop);
    }

    render() {
        const entry = this.props.entry;
        const photos = entry.fields[this.props.configuration.display.record.photo];
        let firstPhoto = true;

        let display = [];
        _.each(this.props.configuration.display.record.fields, (config, index) => {
                try {
                    let exp = jsonata(config.field);
                    let value = exp.evaluate(entry);
                    if (!value && config.fallback) {
                        exp = jsonata(config.fallback);
                        value = exp.evaluate(entry);
                    }

                    if (Array.isArray(value)) {
                        value = value.join(', ');
                    }
                    if (value) {
                        if (config.type === "title") {
                            display.push(
                                (
                                    <Col md={12} key={"entry-"+entry.id+"-details-"+index}>
                                        <h1>
                                            {value}
                                            {this.renderVotingLabel()}
                                        </h1>
                                    </Col>
                                )
                            );
                        } else if (config.type === "text") {
                            display.push(
                                (
                                    <Col md={12}  key={"entry-"+entry.id+"-details-"+index}>
                                        {value}
                                    </Col>
                                )
                            );

                        } else if (config.type === "textNl2br") {
                            display.push(
                                (
                                    <Col md={12}  key={"entry-"+entry.id+"-details-"+index}>
                                        <div className="Record-Info"
                                             dangerouslySetInnerHTML={{__html: value ? this.nl2br(value, true) : null}}/>
                                    </Col>
                                )
                            );
                        } else if (config.type === "html") {
                            display.push(
                                (
                                    <Col md={12} key={"entry-"+entry.id+"-details-"+index}>
                                        <div className="Record-Info"
                                             dangerouslySetInnerHTML={{__html: value}}/>
                                    </Col>
                                )
                            );

                        } else if (config.type === "info") {
                            display.push(
                                (
                                    <Col md={config.md} key={"entry-"+entry.id+"-details-"+index}>
                                        <div className="Record-Detail">
                                            {config.icon ? <i className={config.icon}/> : null}
                                            {config.label ? <b>{config.label}</b> : null}
                                            <span>{value}</span>
                                        </div>
                                    </Col>
                                )
                            );

                        }  else if (config.type === "link") {
                            display.push(
                                (
                                    <Col md={config.md} key={"entry-"+entry.id+"-details-"+index}>
                                        <div className="Record-Detail">
                                            {config.icon ? <i className={config.icon}/> : null}
                                            {config.label ? <b>{config.label}</b> : null}
                                            <a href={config.link === "value" ? value : config.link} target="_blank">
                                                {config.content === "value" ? value : config.content}
                                            </a>
                                        </div>
                                    </Col>
                                )
                            );

                        }
                    }
                } catch (e) {
                }
            }
        );

        const images = [];
        _.each(photos, (photo) => {
            console.log(photo);
            if (photo.thumbnails) {
                images.push({
                    original: photo.thumbnails.large.url,
                    thumbnail: photo.thumbnails.large.url,
                })
            } else {
                images.push({
                    original: photo.url,
                    thumbnail: photo.url,
                })
            }
        })


        return (
            <div className="Record">
                <div style={{textAlign: 'center'}}>
                    <Link to="/" className="Record-Reservation" style={{marginBottom: '20px'}}>
                        Revenir à la liste des activités
                    </Link>
                </div>
                <Row>
                    <Col md={6} style={{textAlign: 'center'}}>
                        <ImageGallery items={images} showPlayButton={false} showNav={images.length > 1} showFullscreenButton={false} showThumbnails={images.length > 1} />
                    </Col>
                    <Col md={6}>
                        <div className="bg-white">
                            <Row>
                                {display}
                            </Row>
                        </div>
                    </Col>
                </Row>

                {this.renderVotingButton()}
            </div>
        );
    }

    nl2br(str, is_xhtml) {
        let breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display

        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    renderVotingButton() {
        const entry = this.props.entry;

        let votingEnabled = true;
        if ("voting" in this.props.configuration) {
            votingEnabled = this.props.configuration.voting.enabled;
        }


        return votingEnabled ? (
            <div style={{textAlign: 'center'}}>
                <button  onClick={(e) => {this.props.onAskForVote(); return false;}} className="Record-Like" style={{marginBottom: '20px'}}>
                    Je vote pour cette activité <i className="fas fa-heart" style={{marginLeft: '10px'}}/>
                </button>
            </div>
        ) : null;

    }

    renderVotingLabel() {
        const entry = this.props.entry;

        let votingEnabled = true;
        if ("voting" in this.props.configuration) {
            votingEnabled = this.props.configuration.voting.enabled;
        }

        return votingEnabled ? (
            <span>
                {entry.id in this.props.voting.stats?  this.props.voting.stats[entry.id] : 0}
                <i className="fas fa-heart"/>
            </span>
        ) : null;
    }

}


export default Record;


// WEBPACK FOOTER //
// ./src/Components/Voting/Record.js